import { Bell, Search, LogOut } from "lucide-react";
import { ThemeToggle } from "./ThemeToggle";
import { useAuthStore } from "@/store/auth.store";
import { useLogout } from "@/hooks/useAuth";

export function Topbar() {
  const user = useAuthStore((s) => s.user);
  const logoutMutation = useLogout();

  return (
    <header className="flex h-16 shrink-0 items-center justify-between border-b border-border bg-card px-6">
      <div className="flex max-w-md flex-1 items-center gap-2 rounded-md border border-border bg-muted/40 px-3 py-1.5 text-sm text-muted-foreground">
        <Search className="h-4 w-4" />
        <span>Search complaint #, phone, customer...</span>
      </div>

      <div className="flex items-center gap-4">
        <ThemeToggle />

        <button
          type="button"
          aria-label="Notifications"
          className="relative flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <Bell className="h-4 w-4" />
          <span className="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-accent" />
        </button>

        {user && (
          <div className="flex items-center gap-3 border-l border-border pl-4">
            <div className="text-right leading-tight">
              <p className="text-sm font-medium">{user.fullName}</p>
              <p className="text-[11px] text-muted-foreground">{user.role}</p>
            </div>
            <button
              type="button"
              aria-label="Log out"
              onClick={() => logoutMutation.mutate()}
              disabled={logoutMutation.isPending}
              className="flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-destructive disabled:opacity-50"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
